export default __webpack_public_path__ + "static/media/frikin.861d7b6b.png";